import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { RefreshCw, CheckCheck, Check, X, Printer } from 'lucide-react';
import { apiGet, apiPost, apiPatch } from '../../lib/api';

export default function Deliveries() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => apiGet('/merchant/deliveries/today').then(r => setList(r.data || [])).catch(e => toast.error(e.message));
  useEffect(() => { load(); }, []);

  const generate = async () => {
    setLoading(true);
    try {
      const r = await apiPost('/merchant/deliveries/generate', {});
      toast.success(r.message);
      load();
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const bulk = async () => {
    if (!window.confirm('Mark all planned deliveries as delivered?')) return;
    await apiPost('/merchant/deliveries/bulk-complete', {});
    toast.success('All marked delivered');
    load();
  };

  const updateOne = async (d, patch) => {
    await apiPatch(`/merchant/deliveries/${d.id}`, patch);
    load();
  };

  return (
    <div className="space-y-5" data-testid="deliveries-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-heading font-extrabold text-3xl text-rozops-navy tracking-tight">Today's Deliveries</h1>
        <div className="flex gap-2">
          <button onClick={generate} disabled={loading} data-testid="gen-btn" className="bg-white border-2 border-rozops-blue-light hover:border-rozops-blue text-rozops-text rounded-xl px-4 py-2.5 font-semibold inline-flex items-center gap-2 disabled:opacity-50"><RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} /> Generate list</button>
          <Link to={`/app/route-sheet?date=${new Date().toISOString().slice(0,10)}`} data-testid="route-sheet-btn" className="bg-white border-2 border-rozops-blue-light hover:border-rozops-blue text-rozops-text rounded-xl px-4 py-2.5 font-semibold inline-flex items-center gap-2"><Printer className="w-4 h-4" /> Route sheet</Link>
          <button onClick={bulk} data-testid="bulk-btn" className="bg-rozops-green hover:bg-rozops-green-dark text-white rounded-xl px-4 py-2.5 font-semibold shadow-soft inline-flex items-center gap-2"><CheckCheck className="w-4 h-4" /> Mark all delivered</button>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft overflow-x-auto">
        <table className="w-full">
          <thead className="bg-rozops-bg border-b border-gray-100">
            <tr className="text-left text-xs uppercase tracking-wider text-rozops-text-muted font-bold">
              <th className="py-3 px-6">Customer</th><th className="py-3 px-6">Product</th><th className="py-3 px-6">Qty</th><th className="py-3 px-6">Amount</th><th className="py-3 px-6">Status</th><th className="py-3 px-6"></th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={6} className="py-10 text-center text-rozops-text-muted">No deliveries planned for today. Click "Generate list" from active subscriptions.</td></tr>}
            {list.map(d => (
              <tr key={d.id} className="border-b border-gray-50 hover:bg-rozops-bg/50" data-testid={`delivery-${d.id}`}>
                <td className="py-4 px-6 font-semibold text-rozops-text">{d.customer?.full_name}</td>
                <td className="py-4 px-6 text-sm">{d.product?.name}</td>
                <td className="py-4 px-6 text-sm">{d.delivered_quantity || d.planned_quantity} {d.product?.unit}</td>
                <td className="py-4 px-6 text-sm font-semibold">₹{Number((d.delivered_quantity || d.planned_quantity) * d.price).toFixed(2)}</td>
                <td className="py-4 px-6">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${d.status === 'delivered' ? 'bg-rozops-green-light text-rozops-green' : d.status === 'skipped' ? 'bg-red-50 text-red-500' : 'bg-amber-50 text-amber-700'}`}>{d.status}</span>
                </td>
                <td className="py-4 px-6 text-right whitespace-nowrap">
                  {d.status !== 'delivered' && <button onClick={() => updateOne(d, { status: 'delivered' })} className="text-rozops-green mr-3" data-testid={`deliver-${d.id}`}><Check className="w-4 h-4 inline" /></button>}
                  {d.status !== 'skipped' && <button onClick={() => updateOne(d, { status: 'skipped' })} className="text-red-500"><X className="w-4 h-4 inline" /></button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
